import moment from 'moment';
import 'moment-duration-format';

/**
 * formatDuration(540) => 09:00
 * formatDuration(8952) => 02:29:12
 *
 * @param {*} time
 * @param {*} unit defaults to seconds
 * @param {*} format defaults to hh:mm:ss
 * @param {*} trim defaults to true
 */
export const formatDuration = (time, unit = 'seconds', format = 'hh:mm:ss', trim = true) => {
    let duration = moment.duration(time, unit);
    return duration.format(format, { trim: trim });
};

/**
 * friendlyTime('00:09:00') => 9 minutes
 * friendlyTime('25:23') => 25 minutes 23 seconds
 *
 * @param {*} timeString "hh:mm:ss" or "mm:ss"
 * @param {*} i18next
 * @param {*} includeSeconds
 */
export const friendlyTime = (timeString, i18next, includeSeconds = false) => {
    let timeArray = timeString.split(':'),
        retVal = '';

    timeArray = timeArray.map(function(t) {
        return parseInt(t, 10);
    });

    // always need hours
    if (timeArray.length < 3) {
        timeArray.splice(0, 0, 0);
    }

    if (timeArray[0] > 0) {
        retVal = i18next.t(timeArray[0] > 1 ? 'common:time_hours' : 'common:time_hour', { 0: timeArray[0] });
    }

    if (timeArray[1] > 0) {
        retVal +=
            ' ' + i18next.t(timeArray[1] > 1 ? 'common:time_minutes' : 'common:time_minute', { 0: timeArray[1] }) + ' ';
    }

    if (includeSeconds && timeArray[2] > 0) {
        retVal += i18next.t(timeArray[2] > 1 ? 'common:time_seconds' : 'common:time_second', { 0: timeArray[2] });
    }

    return retVal;
};
